module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5293fab4f20712e805d99ce816e4fac7.png";